import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizCardFooter - Footer section for quiz card (optional)
 * Copied from EditableQuizCard/QuizCardUI.tsx (QuizCardFooter)
 * @component
 */
const QuizCardFooter = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <div className={cn('flex justify-between py-[14px] w-full px-md border-t border-assistive', className)} ref={ref} {...rest}>
      {children}
    </div>;
});
QuizCardFooter.displayName = 'QuizCardFooter';
export { QuizCardFooter };